import SiteHeader from "../components/SiteHeader";
import SiteFooter from "../components/SiteFooter";
import { useI18n } from "../i18n/I18nContext";
import { BookOpen, Briefcase, Calculator, ScaleIcon, Shield, ShieldCheck, Megaphone, Cpu, Settings, Users, TrendingUp, Crown, Sparkles } from "lucide-react";

const CATEGORIES_VI = [
  { Icon: Briefcase, label: "Kinh doanh" },
  { Icon: Calculator, label: "Kế toán" },
  { Icon: Calculator, label: "Thuế" },
  { Icon: Users, label: "Trả lương" },
  { Icon: ScaleIcon, label: "Pháp lý" },
  { Icon: Users, label: "Lao động" },
  { Icon: ShieldCheck, label: "State Board" },
  { Icon: Shield, label: "An toàn" },
  { Icon: Megaphone, label: "Marketing" },
  { Icon: Cpu, label: "Công nghệ" },
  { Icon: Cpu, label: "AI" },
  { Icon: Settings, label: "Vận hành" },
  { Icon: Users, label: "Dịch vụ khách hàng" },
  { Icon: TrendingUp, label: "Tăng trưởng" },
  { Icon: Crown, label: "Lãnh đạo" },
  { Icon: Sparkles, label: "AsterPOS" },
];

const CATEGORIES_EN = [
  "Business","Accounting","Taxes","Payroll","Legal","Labor","State Board","Safety",
  "Marketing","Technology","AI","Operations","Customer Service","Growth","Leadership","AsterPOS",
];

export default function ResourcesPage() {
  const { lang } = useI18n();
  return (
    <div className="min-h-screen bg-white text-charcoal" data-testid="resources-page">
      <SiteHeader variant="light" />
      <main className="max-w-7xl mx-auto px-6 md:px-10 py-16 md:py-20">
        <p className="text-[11px] uppercase tracking-[0.32em] text-emerald2 font-semibold mb-5">{lang === "en" ? "Learning Center" : "Trung tâm học tập"}</p>
        <h1 className="font-serif text-5xl md:text-6xl text-charcoal">{lang === "en" ? "Learning Center" : "Học Tập"}</h1>
        <p className="mt-4 text-warmgray-700 max-w-2xl">{lang === "en" ? "Business guides, regulations, and best practices to help nail salon owners run stronger, more compliant businesses. Vietnamese-first." : "Hướng dẫn kinh doanh, quy định và phương pháp tốt nhất để giúp chủ tiệm nail vận hành mạnh mẽ và đúng luật. Ưu tiên Tiếng Việt."}</p>

        <div className="mt-12 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
          {CATEGORIES_VI.map(({ Icon, label }, i) => (
            <div key={i} className="bg-white border border-warmgray-200 rounded-3xl p-6 hover:-translate-y-0.5 hover:border-emerald2/40 transition-all" data-testid={`resource-cat-${i}`}>
              <div className="w-12 h-12 rounded-2xl bg-charcoal-900 text-gold-500 flex items-center justify-center"><Icon className="w-5 h-5" /></div>
              <div className="mt-4 font-serif text-xl text-charcoal">{lang === "en" ? CATEGORIES_EN[i] : label}</div>
              <div className="mt-2 text-xs uppercase tracking-[0.22em] text-warmgray-500 font-semibold">{lang === "en" ? "Coming soon" : "Sắp ra mắt"}</div>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-charcoal-900 dark-surface rounded-3xl p-8 md:p-12 text-white relative overflow-hidden">
          <div className="absolute inset-0 summit-gradient opacity-90" />
          <div className="relative">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full border border-gold-500/40 bg-white/5">
              <BookOpen className="w-3.5 h-3.5 text-gold-500" />
              <span className="text-[10px] uppercase tracking-[0.28em] text-gold-300 font-semibold">{lang === "en" ? "Get notified" : "Nhận thông báo"}</span>
            </div>
            <h2 className="mt-4 font-serif text-3xl md:text-4xl">{lang === "en" ? "Articles, videos, and guides — coming soon" : "Bài viết, video, hướng dẫn — sắp ra mắt"}</h2>
            <p className="mt-3 text-white/80 max-w-2xl">{lang === "en"
              ? "We're building the Learning Center with content reviewed by CPAs, attorneys, and salon operators. Want early access?"
              : "Chúng tôi đang xây dựng Trung tâm Học tập với nội dung được CPA, luật sư và chủ tiệm xem xét. Bạn muốn nhận thông báo sớm?"}</p>
          </div>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}
